@if (!this.isLoading) {
  <div>
    <div class="ot-row" style="margin-bottom: 0px !important;">
      <div class="otsc-prop-header">
        <h1 class="otsc-prop-header-text" i18n>Administration Settings for {{activeProduct.name}} {{activeProduct.version}}</h1>
        <div class="ot-btn-group otsc-prop-header-btn">
          <button id="admin-settings-upload-button" role="button" class="ot-btn ot-btn--is-primary"  (click)="validateTasks()" [disabled]="started || !isReadyToUpload()">
            @if (!uploading) {
              <span i18n-title title="Upload" i18n>
                        Upload
                    </span>
            }
            @if (uploading) {
              <div class="ot-progress-container">
                <div id="ot-spinner" class="ot-progress ot-progress--is-spinner">
                  <div class="ot-progress__outer">
                    <div id="submit-button-spinner" class="ot-progress__meter"></div>
                    <div id="submit-button-spinner-text" class="ot-progress__text" i18n-title title="Uploading..." i18n>
                                    Uploading...</div>
                  </div>
                </div>
              </div>
            }
          </button>
          <button id="admin-settings-back-button" role="button" class="ot-btn ot-btn--is-secondary" (click)="back()" [disabled]="started" i18n-title title="Back" i18n>Back</button>
        </div>
      </div>
    </div>
    @if (adminSettingsActivity) {
      <div class="ot-message ot-message--is-progress w-100">
        <div class="ot-message__banner" style="z-index: 1;">
          <p class="ot-message__item" i18n id="admin-settings-running-msg">
            Administration Settings activity is currently running, this page will be temporarily disabled until the activity is complete.&nbsp;<a (click)="goToActivitiesOverview()">View details</a>
          </p>
        </div>
      </div>
    }
    <div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-1" style="height: calc(100vh - 200px);">
      <ng-scrollbar>
        <div class="ot-row ot-pb-1">
          <p style="font-size: 16px;margin-bottom: 0;font-weight: lighter;">
            {{desc}}
          </p>
        </div>
        <form [formGroup]="adminSettingsForm" name="adminSettingsForm">
          <fieldset [disabled]="started || this.adminSettingsActivity !== undefined">
            <div class="ot-row">
              <div class="ot-row__column ot-row__column--is-33">
                <div class="ot-form-control" [ngClass]="{'ot-form-control--is-invalid' : (adminSettingsFileNameCtrl.dirty && adminSettingsFileNameCtrl.errors?.required)}">
                  <label class="ot-form-control__label" for="admin-settings-file-input" i18n>
                                    <div class="ot-form-control__required-indicator">*</div>
                                    Pre-defined administration settings file
                                </label>
                  <label class="ot-file-picker">
                    <input id="admin-settings-file-input" formControlName="adminSettingsFileNameCtrl" placeholder="Select export file" type="file" accept="application/xml, text/xml" class="ot-input ot-input--is-expanded" [(ngModel)]="adminSettingsFile" (change)="fileBrowseHandler($event)">
                    <span>{{adminSettingsFileName ? adminSettingsFileName : chooseFileDefaultStr}}</span>
                    @if (adminSettingsFileNameCtrl.dirty && adminSettingsFileNameCtrl.invalid) {
                      <span class="ot-form-control__error-icon"></span>
                    }
                  </label>
                  @if (adminSettingsFileNameCtrl.dirty && adminSettingsFileNameCtrl.invalid && adminSettingsFileNameCtrl.errors.required) {
                    <span id="adminSettingsFileRequiredMsg" class="ot-form-control__error-text" i18n>
                                    Pre-defined administration settings file is required.
                                </span>
                  }
                </div>
              </div>
            </div>
          </fieldset>
        </form>
        <app-datatable [identifier]="'admin-settings-instance-table'" [title]="agentTableTitle" [cols]="agentCols" [rows]="agentRows"
          [showcheckboxes]="true" [pagination]="false" [disableSelectAllCheckbox]="containsError() || started || this.adminSettingsActivity !== undefined" [scroll]="false" [overrideShowError]="true"
        [isSortable]="false" (actionmenuevent)="actionMenuClicked($event)" (checkboxchangeevent)="validateInstance($event)" [recountSelectedRow]="recountSelectedRow" ></app-datatable>
      </ng-scrollbar>
    </div>
  </div>
} @else {
  <div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
    <div class="ot-progress__outer">
      <div class="ot-progress__meter"></div>
    </div>
    @if (isLoading && !isManifestUpdating && !isAgentManifestUpdating) {
      <div class="ot-progress__text" i18n>Loading...</div>
    }
    @if (isManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
    }
    @if (isAgentManifestUpdating) {
      <div class="ot-progress__text" i18n>Please wait while the Agent manifest is updated...</div>
    }
  </div>
}
